export const messagesSms = {
    pt: {
        message:{
            createSms: "Criar SMS",
            editSms: "Editar SMS",
            newSms: "Novo SMS",
            number: "Número",
            numberHint: "Insira apenas os números do DDD + telefone (Ex. 4840420132)",
            skipTest: "Pular Teste",
            smsAutomationInfo: "Crie um SMS que será utilizado nos seus fluxos de automação do WiFeed.",
            smsName: "Nome do SMS",
            smsPurpose: "Finalidade do SMS:",
            smsSingleSendInfo: "Envie seu SMS uma única vez para sua base de clientes a partir de uma segmentação.",
            tooltipSmsName: "Nome que será utilizado para identificar o SMS dentro do WiFeed."

        }
    },
    es: {
        message:{
            createSms:"Crear SMS",
            editSms:"Editar SMS",
            newSms:"Nuevo SMS",
            number:"Número",
            numberHint:"Inserte solo los números de DDD + Phone (Ex. 4840420132)",
            skipTest:"Saltear Prueba",
            smsAutomationInfo:"Cree un SMS que se utilizará en sus flujos de automatización de WiFeed",
            smsName:"Nombre de SMS",
            smsPurpose:"Propósito SMS:",
            smsSingleSendInfo:"Envíe su SMS una vez a su base de clientes desde una segmentación",
            tooltipSmsName:"Nombre que se usará para identificar SMS dentro de WiFeed"
        }
    },
    en: {
        message:{
            createSms: "Create SMS",
            editSms: "Edit SMS",
            newSms: "New SMS",
            number: "Number",
            numberHint: "Enter only the area code + telephone numbers (Ex. 4840420132)",
            skipTest: "Skip Test",
            smsAutomationInfo: "Create an SMS that will be used in your WiFeed automation flows.",
            smsName: "SMS name",
            smsPurpose: "Purpose of the SMS:",
            smsSingleSendInfo: "Send your SMS just once to your customer base based on segmentation.",
            tooltipSmsName: "Name that will be used to identify the SMS within WiFeed."


        }
    }
}
